import { render } from "./SummaryBox5.vue?vue&type=template&id=e21563e0&scoped=true"
import script from "./SummaryBox5.vue?vue&type=script&lang=js"
export * from "./SummaryBox5.vue?vue&type=script&lang=js"

import "./SummaryBox5.vue?vue&type=style&index=0&id=e21563e0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e21563e0"]])

export default __exports__